<template>
    <Component
        :is="componentInstance"
        v-bind="$attrs"
        :get-data-vuex="getLandings"
        :placeholder="placeholder"
        :multiple="multiple"
        :value="value"
        class="white"
        field="name"
        @[event]="$emit(event, $event)">
    </Component>
</template>
<script>
  import { UsersSelect } from "@core/mixins/select/usersSelect";

  export default {
    name: "LandingSelect",
    mixins: [UsersSelect],

    props: {
      routeParam: {
        type: String,
        default: "pageId"
      },

      namespaceModule: {
        type: String,
        default: "landingFilters"
      }
    },

    methods: {
      async getLandings (label = "", isLoading = false) {
        await this.getFiltersByName(this.namespaceModule, this.list, this.$route.query[this.routeParam] ?? this.value,
                                    this.routeParam, label, isLoading, this.filterOptions);
        return this.list;
      }
    }
  };
</script>

<style scoped>

</style>